"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.ViewReceiptsButton=exports.SuccessScreenContainer=exports.LoaderContainer=exports.IosCircleContainer=exports.ImageContainer=exports.FormCheckRadio=exports.EmptyDiv=exports.EmailTypographyContainer=exports.EmailTypography=exports.EmailSubHeading=exports.EmailReceiptText=exports.EmailMsgContainer=exports.EmailFreeText=exports.EmailFormControl=exports.EmailButton=void 0;const EmailSubHeading=exports.EmailSubHeading=_styledComponents.default.div`
    margin: 1rem 0;
    height: 24px;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    color: #1C1C1C;
`,EmailTypographyContainer=exports.EmailTypographyContainer=_styledComponents.default.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 1rem;

    .email-string {
        max-width: 280px;
        overflow-wrap: break-word;
        word-wrap: break-word;
        hyphens: auto;
    }

    .email-d-flex{
        display: flex !important;
    }

    .justify-content-space-btwn {
        justify-content: space-between;
    }

    .justify-content-end {
        display: flex;
        justify-content: end;
    }
    
    .alig-items-baseline{
        align-items: baseline;
    }

    .margin-bottom-2 {
        margin-bottom: .5rem !important;
    }

     .email-btn.email-button {
        box-shadow: none;
        transition: all .35s;
    }

    .email-btn {
        display: inline-block;
        color: #7b1a27;
        text-align: center;
        vertical-align: middle;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-color: transparent;
        border: 1px solid transparent;
        font-size: 1rem;
        line-height: 1.5;
        border-radius: .25rem;
        transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }

    

    .theme-red .email-btn.email-button.email-btn-link {
        color: #7b1a27;
    }

    .email-btn.email-button.email-btn-link {
        margin: 0;
        margin-left: 0px;
        padding: 0;
    }

    .email-btn:not(:disabled):not(.disabled) {
     cursor: pointer;
    }

    .email-btn.email-button.email-btn-link:hover {
        text-align: center;
    }

    .email-btn-secondary.disabled, .email-btn-secondary:disabled {
        color: #fff;
        background-color: #6c757d;
        border-color: #6c757d;
    }

    .email-btn.disabled, .email-btn:disabled {
        opacity: .65;
        background-color: #6c757d !important;
    }

    .core-btn {
        border-radius: 100px;
        background-color: #7b1a27 !important;
    }

    .email-btn-secondary {
        color: #fff;
        background-color: #6c757d;
        border-color: #6c757d;
    }

    .cancel-btn {
        justify-content: center;
    }

    .text-center {
        text-align: center;
    }
`,EmailTypography=exports.EmailTypography=_styledComponents.default.label`
    display: inline-block;
    margin: 0.5rem 0;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.37px;
    color: #595959;
    max-width: 280px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  
`,EmailFreeText=exports.EmailFreeText=_styledComponents.default.div`
    margin: 0.5rem 0;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.37px;
    color: #595959;
`,EmailFormControl=exports.EmailFormControl=_styledComponents.default.div`

    .form-control {
        display: block;
        width: 320px;
        height: calc(1.5em + .75rem + 2px);
        padding: .375rem .75rem;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: .25rem;
        transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }

    .form-control.form-control-email {
        border: 1.2px solid #ddd9d5;
        border-radius: .5rem;
        box-shadow: none;
    }

    .errorMsg {
        margin: 8px 0;
        color: #7B1A27;
        display: block;
        text-align: left;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        letter-spacing: 0.37px;

    }

    .form-control.form-control-email::placeholder{
        height: 20px;
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 20px;
        letter-spacing: 0.422857px;
        color: #C8C7CC;
    }
`,EmailButton=exports.EmailButton=_styledComponents.default.button`
    background: #2B0810;
    border-radius: 4px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    text-transform: uppercase;
    color: #FFFFFF;
    width: 100%;
    margin: 1.5rem 0rem;
    padding: 20px 30px;

   :disabled{
     background-color: #C8C7CC;
    }

    :hover{
        background: #FFFFFF;
        color: #2B0810;
        cursor: pointer;
     }
`,EmailMsgContainer=exports.EmailMsgContainer=_styledComponents.default.p`
    margin: 0.5rem 0;
    display: flex;
    align-items: center;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 0.37px;
    
    &.success-msg {
        color: #448255;
    }
`,SuccessScreenContainer=exports.SuccessScreenContainer=_styledComponents.default.div`
    margin-top: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`,EmailReceiptText=exports.EmailReceiptText=_styledComponents.default.p`
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    /* identical to box height, or 125% */

    text-align: center;

    color: #595959;
`,ViewReceiptsButton=exports.ViewReceiptsButton=_styledComponents.default.button`
    padding: 8px;
    background: #2B0810;
    border-radius: 4px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 18px;
    /* identical to box height, or 150% */

    text-align: center;
    text-transform: uppercase;

    color: #FFFFFF;

    :hover{
        background: #FFFFFF;
        color: #2B0810;
        cursor: pointer;
     }
`,IosCircleContainer=exports.IosCircleContainer=_styledComponents.default.div`
    font-size: 3rem;
    color: #448255;
`,LoaderContainer=exports.LoaderContainer=_styledComponents.default.div`
    text-align: center;
`,ImageContainer=exports.ImageContainer=_styledComponents.default.div`
    margin: 2rem 0 2rem 0;
    display: flex;
    justify-content: center;

    .email-icon {
      width: 60px;
      height: 60px;
    }
`,EmptyDiv=exports.EmptyDiv=_styledComponents.default.div`
    margin: 2.2rem 0;
`,FormCheckRadio=exports.FormCheckRadio=_styledComponents.default.div`
    display: flex;
    align-items: center;
    justify-content: center;
    
   .radio-btn {
    height: 18px;
    width: 18px;
    accent-color: #7B1A27;
   }
`;